import { useEffect } from "react";

const useInfiniteScroll = ({
  ref,
  hasMore,
  isLoading,
  onLoadMore,
  threshold = 100,
  direction = "down", // "down" or "up"
}) => {
  useEffect(() => {
    const handleScroll = () => {
      const container = ref.current;

      if (!container || isLoading || !hasMore) return;

      if (direction === "down") {
        const reachedBottom =
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - threshold;

        if (reachedBottom) onLoadMore();
      } else if (direction === "up") {
        const reachedTop = container.scrollTop <= threshold;

        if (reachedTop) onLoadMore();
      }
    };

    const current = ref.current;
    current?.addEventListener("scroll", handleScroll);
    return () => current?.removeEventListener("scroll", handleScroll);
  }, [ref, hasMore, isLoading, onLoadMore, threshold, direction]);
};

export default useInfiniteScroll;
